export enum NotificationTypes {
    Err = 'error'
}